import { parse, stringify } from 'hub-http/helpers/params';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Metrics } from 'LearningCenterUI/Metrics';
import { usePlaylist } from '../savedItems';
export const useIncorrectPlaylistRedirect = (playlistId, trackId, lessonId) => {
  const {
    playlist,
    playlistLoading,
    playlistError
  } = usePlaylist(playlistId);
  const history = useHistory();
  useEffect(() => {
    const playlistMissing = playlistError || !playlistLoading && !playlist;
    const trackMissing = playlist && trackId && !playlist.items.find(item => item.type === 'TRACK' && item.itemId === Number(trackId));
    const lessonMissing = playlist && lessonId && !playlist.items.find(item => item.type === 'LESSON' && item.itemId === Number(lessonId));

    if (playlistMissing || trackMissing || lessonMissing) {
      const params = parse(history.location.search.slice(1));
      delete params.playlistId;
      const newSearch = stringify(params);
      history.push(Object.assign({}, history.location, {
        search: newSearch.length > 1 ? newSearch : ''
      }));
    }

    if (playlistMissing) {
      Metrics.counter('current-playlist-missing-redirect').increment();
    } else if (trackMissing) {
      Metrics.counter('current-track-not-in-playlist-redirect').increment();
    } else if (lessonMissing) {
      Metrics.counter('current-lesson-not-in-playlist-redirect').increment();
    }
  }, [history, lessonId, playlist, playlistError, playlistLoading, trackId]);
};
export const usePlaylistIdFromSearch = () => {
  const {
    search
  } = useLocation();
  const params = new URLSearchParams(search);
  const playlistIdSearchString = params.get('playlistId');
  if (playlistIdSearchString) return parseInt(playlistIdSearchString, 10);
  return null;
};